import PropTypes from 'prop-types';
import React, { memo, useState } from 'react';
import cx from 'classnames';
import Icon, { defaultColors } from '@digitransit-component/digitransit-component-icon';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles_suggestion-item-container__kZSH5 {\n  display: flex;\n  min-height: 25px;\n}\n.styles_suggestion-item-container__kZSH5.styles_futureroute__Nx-kb {\n  min-height: 79px;\n}\n\n.styles_mobile__WTq9F {\n  height: 59px;\n  margin: 0 10px;\n}\n.styles_mobile__WTq9F.styles_CurrentLocation__oweM0 {\n  height: 50px;\n}\n.styles_mobile__WTq9F.styles_SelectFromMap__ZjYDL {\n  height: 50px;\n}\n\nli:not(:first-child) > div.styles_suggestion-item-container__kZSH5 {\n  border-top: 1px solid #ddd;\n}\n\nli:last-child > div.styles_suggestion-item-container__kZSH5.styles_mobile__WTq9F {\n  border-top: none;\n}\n\n.styles_search-result__1cmie {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  min-height: 49px;\n}\n.styles_search-result__1cmie.styles_futureroute__Nx-kb {\n  min-height: 79px;\n}\n.styles_search-result__1cmie .styles_suggestion-result__EpsZy {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  position: absolute;\n  padding-left: 49px;\n  padding-right: 27px;\n}\n.styles_search-result__1cmie .styles_suggestion-result__EpsZy .styles_suggestion-name__k-DZQ {\n  margin: 0;\n  font-weight: var(--font-weight-medium);\n  color: #333;\n  font-size: 15px !important;\n  letter-spacing: -0.5px;\n  line-height: 1.5;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n@media screen and (min-width: 768px) {\n  .styles_search-result__1cmie .styles_suggestion-result__EpsZy .styles_suggestion-name__k-DZQ {\n    font-size: 13px !important;\n    letter-spacing: -0.43px;\n    line-height: 1;\n  }\n}\n.styles_search-result__1cmie .styles_suggestion-result__EpsZy .styles_suggestion-name__k-DZQ.styles_futureroute__Nx-kb {\n  line-height: 1.33;\n  position: relative;\n  left: 2px;\n}\n.styles_search-result__1cmie .styles_suggestion-result__EpsZy .styles_suggestion-name__k-DZQ.styles_futureroute__Nx-kb.styles_normal__a1p7s {\n  font-weight: normal;\n  position: relative;\n  left: 0.5px;\n}\n.styles_search-result__1cmie .styles_suggestion-result__EpsZy .styles_suggestion-label__0B0NY {\n  margin: 0;\n  color: #666;\n  font-size: 13px !important;\n  font-weight: 400;\n  letter-spacing: -0.43px;\n  line-height: 1.38;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  position: relative;\n  top: -1px;\n  margin-top: 3px;\n}\n@media screen and (min-width: 768px) {\n  .styles_search-result__1cmie .styles_suggestion-result__EpsZy .styles_suggestion-label__0B0NY {\n    font-size: 11px !important;\n    letter-spacing: -0.37px;\n    line-height: 1.64;\n  }\n}\n.styles_search-result__1cmie .styles_suggestion-result__EpsZy .styles_suggestion-label__0B0NY .styles_stop-code__81UNK {\n  display: inline-block;\n  border-radius: 3px;\n  font-size: 9px;\n  line-height: 9px;\n  padding: 1px 2px 1px;\n  font-weight: var(--font-weight-medium);\n  border: 1px solid #ddd;\n  margin: 0 4px;\n  vertical-align: middle;\n}\n.styles_search-result__1cmie .styles_suggestion-result__EpsZy .styles_suggestion-label__0B0NY .styles_platform__khmUF {\n  display: inline-block;\n  background: #f2f5f7;\n  color: #333;\n  border-radius: 3px;\n  font-weight: 500;\n  text-align: center;\n  margin-left: 5px;\n  height: 16px;\n  width: 24px;\n  align-self: center;\n  font-family: var(--font-family-narrow);\n}\n.styles_search-result__1cmie .styles_suggestion-result__EpsZy .styles_suggestion-label__0B0NY.styles_futureroute__Nx-kb {\n  height: 18px;\n  position: relative;\n  left: 2px;\n  top: 4px;\n}\n.styles_search-result__1cmie .styles_arrow-icon__D1KA4 {\n  display: flex;\n  width: 27px;\n  align-items: center;\n  position: absolute;\n  right: 0;\n}\n.styles_search-result__1cmie .styles_arrow-icon__D1KA4 svg {\n  width: 17px;\n  height: 17px;\n}\n.styles_search-result__1cmie .styles_arrow-icon__D1KA4.styles_mobile__WTq9F.styles_fill-input__LnoJG {\n  border-left: 1px solid #ddd;\n  width: 48px;\n  height: 40px;\n  padding-right: 10px;\n  padding-left: 20px;\n}\n.styles_search-result__1cmie .styles_arrow-icon__D1KA4.styles_mobile__WTq9F svg {\n  width: 12px;\n  height: 21px;\n}\n.styles_search-result__1cmie .styles_arrow-icon__D1KA4.styles_mobile__WTq9F {\n  right: -9px;\n}\n\n.styles_suggestion-icon__DON5x {\n  width: 49px;\n  text-align: center;\n  padding-top: 6px;\n}\n.styles_suggestion-icon__DON5x svg {\n  width: 22px;\n  height: 22px;\n}\n.styles_suggestion-icon__DON5x .styles_place__CP-Qp svg,\n.styles_suggestion-icon__DON5x .styles_busstop__z-xHf svg,\n.styles_suggestion-icon__DON5x .styles_select-from-map__YtH5a svg {\n  width: 24px;\n  height: 24px;\n}\n.styles_suggestion-icon__DON5x .styles_locate__UfeUB svg,\n.styles_suggestion-icon__DON5x .styles_edit__blnDw svg {\n  width: 22px;\n  height: 22px;\n}\n.styles_suggestion-icon__DON5x .styles_star__N8ZOs svg,\n.styles_suggestion-icon__DON5x .styles_work__0h7bm svg {\n  width: 20px;\n  height: 20px;\n}\n.styles_suggestion-icon__DON5x .styles_school__OwVaM svg,\n.styles_suggestion-icon__DON5x .styles_sport__cnre8 svg,\n.styles_suggestion-icon__DON5x .styles_shopping__xXtkK svg {\n  width: 18px;\n  height: 18px;\n}\n.styles_suggestion-icon__DON5x .styles_arrow__rGnN9 svg {\n  width: 17px;\n  height: 17px;\n  transform: rotate(180deg);\n}\n.styles_suggestion-icon__DON5x .styles_future-route__Oq85m svg {\n  width: 32px;\n  height: 32px;\n  position: relative;\n  top: -11px;\n}\n.styles_suggestion-icon__DON5x .styles_station__biXY1 svg {\n  width: 25px;\n  height: 24px;\n}\n\n.styles_sr-only__JwB12:not(:focus, :active) {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}";
var styles = {"suggestion-item-container":"styles_suggestion-item-container__kZSH5","futureroute":"styles_futureroute__Nx-kb","mobile":"styles_mobile__WTq9F","CurrentLocation":"styles_CurrentLocation__oweM0","SelectFromMap":"styles_SelectFromMap__ZjYDL","search-result":"styles_search-result__1cmie","suggestion-result":"styles_suggestion-result__EpsZy","suggestion-name":"styles_suggestion-name__k-DZQ","normal":"styles_normal__a1p7s","suggestion-label":"styles_suggestion-label__0B0NY","stop-code":"styles_stop-code__81UNK","platform":"styles_platform__khmUF","arrow-icon":"styles_arrow-icon__D1KA4","fill-input":"styles_fill-input__LnoJG","suggestion-icon":"styles_suggestion-icon__DON5x","place":"styles_place__CP-Qp","busstop":"styles_busstop__z-xHf","select-from-map":"styles_select-from-map__YtH5a","locate":"styles_locate__UfeUB","edit":"styles_edit__blnDw","star":"styles_star__N8ZOs","work":"styles_work__0h7bm","school":"styles_school__OwVaM","sport":"styles_sport__cnre8","shopping":"styles_shopping__xXtkK","arrow":"styles_arrow__rGnN9","future-route":"styles_future-route__Oq85m","station":"styles_station__biXY1","sr-only":"styles_sr-only__JwB12"};
styleInject(css_248z);

/* eslint-disable import/no-extraneous-dependencies */
const extendedModes = {
  702: 'bus-express',
  704: 'bus-local',
  714: 'replacement-bus',
  900: 'speedtram'
};
const getRouteMode = (props, set) => {
  let eMode;
  if (set === 'hsl') {
    eMode = extendedModes[props.type];
  }
  return eMode || props.mode?.toLowerCase() || 'bus';
};
const iconProps = {
  bikestation: ['citybike'],
  currentPosition: ['position'],
  locality: ['city'],
  station: ['station'],
  localadmin: ['city'],
  neighbourhood: ['city'],
  edit: ['edit'],
  'icon-icon_home': ['home'],
  'icon-icon_work': ['work'],
  'icon-icon_sport': ['sport'],
  'icon-icon_school': ['school'],
  'icon-icon_shopping': ['shopping'],
  selectFromMap: ['map'],
  ownLocations: ['star'],
  back: ['arrow', 'accessiblePrimary'],
  futureRoute: ['future-route'],
  // map unusual transport modes
  'subway-stop': ['subway', 'subway'],
  'airplane-stop': ['airplane', 'airplane'],
  'bus-express-hsl': ['bus-hsl', 'bus-express'],
  'bus-express-stop-hsl': ['bus-stop-hsl', 'bus-express'],
  'bus-express-digitransit': ['bus-digitransit', 'bus'],
  'bus-express-stop-digitransit': ['bus-stop-digitransit', 'bus'],
  'speedtram-digitransit': ['tram', 'tram'],
  'speedtram-stop-digitransit': ['tram-stop-digitransit', 'tram'],
  'ferry-stop-hsl': ['ferry-stop-hsl', 'ferry-external'],
  'ferry-stop-digitransit': ['ferry-stop-digitransit', 'ferry-external'],
  'bus-tram-stop-digitransit': ['bustram-stop-digitransit', 'tram']
};
function isFavourite(item) {
  return item.type?.includes('Favourite');
}
function getAriaDescription(ariaContentArray) {
  const description = ariaContentArray.filter(part => part !== undefined && part !== null && part !== '').join(' ');
  return description?.toLowerCase();
}
const stopLayers = ['station', 'stop'];
const parkLayers = ['bikepark', 'carpark'];
const noTheme = ['subway', 'airplane', 'funicular']; // common icon in all themes

function getIconProps(mode, isStop, modeSet) {
  // select stop lollipop or mode/station icon
  const stopDesc = isStop ? '-stop' : '';
  // is the icon theme specific
  const themePostfix = noTheme.includes(mode) ? '' : `-${modeSet}`;
  return iconProps[`${mode}${stopDesc}${themePostfix}`] || [`${mode}${stopDesc}${themePostfix}`, mode];
}
function getIconProperties(item, modeSet, stopCode, modes) {
  let iconId;

  // because of legacy favourites there might be selectedIconId for some stops or stations
  // but we do not want to show those icons
  if (isFavourite(item)) {
    return ['star'];
  }
  if (item.type === 'Route' || item.type === 'OldSearch' && item.properties?.mode) {
    const mode = getRouteMode(item.properties, modeSet);
    return getIconProps(mode, false, modeSet);
  }
  if (item.selectedIconId) {
    iconId = item.selectedIconId;
  } else if (item.properties) {
    if (item.properties.layer === 'bikestation') {
      return [`citybike-stop-${modeSet}`, 'citybike'];
    }
    if (parkLayers.includes(item.properties.layer)) {
      return [item.properties.layer, item.properties.layer];
    }
    if (item.properties.label?.split(',').length === 1 && !isFavourite(item) && !stopLayers.includes(item.properties.layer)) {
      return ['city'];
    }
    iconId = item.properties.layer;
  }
  // Use more accurate icons in stop/station search, depending on mode from geocoding
  if (modes?.length) {
    let station = item.properties.layer === 'station';
    let mode; // select dominating mode
    if (modes.includes('SPEEDTRAM')) {
      mode = 'speedtram';
    } else if (modes.includes(!station)) {
      mode = 'bus-express';
    } else {
      mode = modes[0].toLowerCase();
    }
    station = station || mode === 'ferry' && stopCode;
    return getIconProps(mode, !station, modeSet);
  }
  return iconProps[iconId] || ['place'];
}

/** *
 * Checks if stationId is a number. We don't want to display random hashes or names.
 *
 * @param stationId station's id, TODO we should probably support GBFS short_name
 */
function hasVehicleStationCode(stationId) {
  return (
    // eslint-disable-next-line no-restricted-globals
    !isNaN(stationId) &&
    // eslint-disable-next-line no-restricted-globals
    !isNaN(parseFloat(stationId))
  );
}

/**
 * SuggestionItem renders suggestions for digitransit-autosuggest component.
 * @example
 * <SuggestionItem
 *    item={suggestionObject}
 *    content={['Pysäkki', 'Kuusitie', 'Helsinki', 'H1923']}
 *    loading={false}
 * />
 */
const SuggestionItem = /*#__PURE__*/memo(({
  item,
  content,
  loading,
  isMobile,
  ariaFavouriteString,
  fillInput,
  fontWeights,
  colors,
  getAutoSuggestIcons,
  modeSet
}) => {
  const [suggestionType, name, label, stopCode, modes, platform] = content || ['', item.name, item.address];
  let iconId;
  let iconColor;
  if (item.properties?.layer && getAutoSuggestIcons?.[item.properties?.layer]) {
    [iconId, iconColor] = getAutoSuggestIcons[item.properties.layer](item);
  } else {
    let colorId;
    [iconId, colorId] = getIconProperties(item, modeSet, stopCode, modes);
    if (item.properties?.color) {
      iconColor = `#${item.properties.color}`;
    } else if (iconId === 'position' || isFavourite(item)) {
      iconColor = colors?.primary || defaultColors.primary;
    } else {
      iconColor = colors?.[colorId] || defaultColors[colorId] || '#888';
    }
  }
  const accessiblePrimary = colors?.accessiblePrimary || defaultColors.accessiblePrimary;
  // console.log(item, iconId, iconColor);
  // Arrow clicked is for street. Instead of selecting item when a user clicks on arrow,
  // It fills the input field.
  const [arrowClicked, setArrowClicked] = useState(false);
  const icon = /*#__PURE__*/React.createElement("span", {
    className: styles[iconId]
  }, /*#__PURE__*/React.createElement(Icon, {
    color: iconColor,
    img: iconId
  }));
  let ariaParts;
  if (name !== stopCode) {
    ariaParts = isFavourite(item) ? [ariaFavouriteString, suggestionType, name, stopCode, label] : [suggestionType, name, stopCode, label];
  } else {
    ariaParts = isFavourite(item) ? [ariaFavouriteString, suggestionType, name, label] : [suggestionType, name, label];
  }
  const ariaDescription = getAriaDescription(ariaParts);
  const acri = /*#__PURE__*/React.createElement("div", {
    className: styles['sr-only']
  }, /*#__PURE__*/React.createElement("p", null, ariaDescription));
  const isFutureRoute = iconId === 'future-route';
  const isVehicleRentalStation = item.properties?.layer === 'favouriteVehicleRentalStation' || item.properties?.layer === 'bikestation';
  const isParkingArea = item.properties?.layer === 'carpark' || item.properties?.layer === 'bikepark';
  const labelWithLocationType = isVehicleRentalStation || isParkingArea ? suggestionType.concat(item.properties.localadmin ? `, ${item.properties.localadmin}` : '') : label;
  const ri = /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: cx(styles['search-result'], loading && "loading", isFutureRoute && styles.futureroute)
  }, /*#__PURE__*/React.createElement("span", {
    "aria-label": suggestionType,
    className: styles['suggestion-icon']
  }, icon), /*#__PURE__*/React.createElement("div", {
    className: cx(styles['suggestion-result'], isFutureRoute && styles.futureroute)
  }, iconId !== 'future-route' && item.selectedIconId !== 'favourite' && iconId !== 'edit' && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: styles['suggestion-name']
  }, name), /*#__PURE__*/React.createElement("div", {
    className: styles['suggestion-label']
  }, isVehicleRentalStation || isParkingArea ? labelWithLocationType : label, ' ', (!isVehicleRentalStation && stopCode && stopCode !== name || isVehicleRentalStation && hasVehicleStationCode(stopCode || item.properties.id)) && /*#__PURE__*/React.createElement("span", {
    className: styles['stop-code']
  }, stopCode || item.properties.id), platform?.length === 2 && /*#__PURE__*/React.createElement(React.Fragment, null, platform[0].toLowerCase(), ' ', /*#__PURE__*/React.createElement("span", {
    className: styles.platform
  }, platform[1])))), (item.selectedIconId === 'favourite' || iconId === 'edit') && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
    className: styles['suggestion-name']
  }, name)), iconId === 'future-route' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: cx(styles['suggestion-name'], styles.futureroute)
  }, item.properties.origin.name, /*#__PURE__*/React.createElement("span", {
    className: cx(styles['suggestion-name'], styles.futureroute, styles.normal)
  }, item.properties.origin.localadmin ? `, ${item.properties.origin.localadmin.split('*')[0]}` : '')), /*#__PURE__*/React.createElement("div", {
    className: cx(styles['suggestion-name'], styles.futureroute)
  }, item.properties.destination.name, /*#__PURE__*/React.createElement("span", {
    className: cx(styles['suggestion-name'], styles.futureroute, styles.normal)
  }, item.properties.destination.localadmin ? `, ${item.properties.destination.localadmin.split('*')[0]}` : '')), /*#__PURE__*/React.createElement("div", {
    className: cx(styles['suggestion-label'], isFutureRoute && styles.futureroute)
  }, item.translatedText))), iconId !== 'arrow' && (item.properties?.layer !== 'street' || !isMobile || arrowClicked) && /*#__PURE__*/React.createElement("span", {
    className: cx(styles['arrow-icon'], isMobile && styles.mobile)
  }, /*#__PURE__*/React.createElement(Icon, {
    img: "arrow",
    color: accessiblePrimary
  })), iconId !== 'arrow' && item.properties?.layer === 'street' && !arrowClicked && isMobile &&
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
  React.createElement("span", {
    className: cx(styles['arrow-icon'], isMobile && styles.mobile, !arrowClicked && styles['fill-input']),
    onClick: () => {
      // Input is already filled for this item, no need
      // To fill it again
      if (arrowClicked) {
        return;
      }
      setArrowClicked(true);
      // eslint-disable-next-line no-param-reassign
      item.properties.arrowClicked = true;
      fillInput(item);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    img: "search-street-name",
    color: accessiblePrimary
  })));
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles['suggestion-item-container'], styles[item.type], isMobile && styles.mobile, isFutureRoute && styles.futureroute),
    style: {
      '--font-weight-medium': fontWeights.medium
    }
  }, acri, ri);
});
process.env.NODE_ENV !== "production" ? SuggestionItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
    address: PropTypes.string,
    selectedIconId: PropTypes.string,
    translatedText: PropTypes.string,
    properties: PropTypes.shape({
      layer: PropTypes.string,
      color: PropTypes.string,
      localadmin: PropTypes.string,
      mode: PropTypes.string,
      id: PropTypes.string,
      source: PropTypes.string,
      arrowClicked: PropTypes.bool,
      destination: PropTypes.shape({
        name: PropTypes.string,
        localadmin: PropTypes.string
      }),
      origin: PropTypes.shape({
        name: PropTypes.string,
        localadmin: PropTypes.string
      })
    })
  }).isRequired,
  // eslint-disable-next-line
  content: PropTypes.array,
  isMobile: PropTypes.bool,
  ariaFavouriteString: PropTypes.string,
  loading: PropTypes.bool,
  fillInput: PropTypes.func,
  fontWeights: PropTypes.shape({
    medium: PropTypes.number
  }),
  getAutoSuggestIcons: PropTypes.objectOf(PropTypes.func),
  colors: PropTypes.objectOf(PropTypes.string),
  modeSet: PropTypes.string
} : void 0;
SuggestionItem.defaultProps = {
  loading: false,
  ariaFavouriteString: '',
  fillInput: () => {},
  isMobile: false,
  fontWeights: {
    medium: 500
  },
  colors: undefined,
  getAutoSuggestIcons: {
    citybikes: station => {
      const name = station.properties.source === 'citybikesvantaa' ? 'citybike-stop-hsl-secondary' : 'citybike-stop-hsl';
      return [name, defaultColors.citybike];
    }
  },
  modeSet: 'hsl'
};

export { SuggestionItem as default };
//# sourceMappingURL=index.js.map
